// eslint-disable-next-line import/prefer-default-export
import { mapGetters } from 'vuex';

export const listUsers = {
  data: () => ({
    users: [],
    usersSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: 'givenName,familyName',
    },
    usersLoading: true,
    usersListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    users() {
      this.usersLoading = false;
    },
  },
};

export const getMe = {
  async created() {
    // console.log('Users Mixin created()');
    // if (this.token) {
    //   await this.$store.dispatch('users/getMe');
    // }
    //
    // console.log('Finished users mixin created()');
  },
  watch: {
    token(newValue) {
      if (newValue) {
        this.$store.dispatch('users/getMe');
      }
    },
  },
  computed: {
    ...mapGetters({
      token: 'authentication/token',
      meDisplayName: 'users/meDisplayName',
      me: 'users/me',
    }),
  },
};
